export class ImportedData {
  constructor(
    readonly data: Record<string, any>,
    readonly caseID: string,
    readonly metaData: Record<string, any>,
  ) { }
}
